<div id="notification-alerts">
    @for (message of getMessages(); track message; let i = $index) {
        <div class="alert alert-{{message.type}}">
            <span>{{message.text}}</span>
            <button
                type="button"
                class="close"
                (click)="closeMessage(message)">
                &times;
            </button>
        </div>
    }
</div>
